exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*.check-box-xs-no-wrap{\r\n\r\n  mat-checkbox label.mat-checkbox-layout {\r\n    white-space: normal;\r\n  }\r\n\r\n}*/\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/components/claim/clm-declaration/clm-declaration.component.scss
// module id = ../../../../../src/app/components/claim/clm-declaration/clm-declaration.component.scss
// module chunks = main